/* eslint-disable no-extra-parens */

import React from 'react'
import {SideMenuChannelSettingsView} from './components/SideMenuChannelSettingsView'

import {SideMenuHomeView} from './components/SideMenuHomeView'
import {SideMenuQueueSettingsView} from './components/SideMenuQueueSettingsView'
import {SideMenuQueueStatisticsView} from './components/SideMenuQueueStatisticsView'
import {SideMenuRealmView} from './components/SideMenuRealmView'
import {SideMenuSettingsView} from './components/SideMenuSettingsView'
import {SideMenuViewProps} from './types'

import {
    container,
} from './styles'

import {styled} from 'stitches/config'

const StyledContainer = styled('div', container)

const SideMenuView = (props: SideMenuViewProps): React.ReactElement => {
    const {
        view, routeParams,
    } = props

    return (
        <StyledContainer>
            {(view === 'ChannelSettings' && <SideMenuChannelSettingsView />) ||
                (view === 'QueueSettings' && <SideMenuQueueSettingsView />) ||
                (view === 'QueueStatistics' && <SideMenuQueueStatisticsView routeParams={routeParams} />) ||
                (view === 'Realm' && <SideMenuRealmView />) ||
                (view === 'Settings' && <SideMenuSettingsView />) ||
                <SideMenuHomeView />}
        </StyledContainer>
    )
}

export default SideMenuView
